import { useAuth } from "@/contexts/AuthContext";
import { getInitials } from "@/lib/utils";
import * as shared from "@/styles/shared";
import type { TopBarProps } from "@/types/ui";
import { LogOut, Menu } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import LanguageSwitcher from "./LanguageSwitcher";
import ThemeToggle from "./ThemeToggle";
import { resolveTitleKey } from "./TopBar.constants";
import * as styles from "./TopBar.styles";

const TopBar = ({ onMenuClick }: TopBarProps) => {
  const { t } = useTranslation(["common", "components"]);
  const { user, logout } = useAuth();
  const location = useLocation();

  const pageTitleKey = resolveTitleKey(location.pathname);
  const pageTitle = t(pageTitleKey);

  return (
    <header className={styles.header}>
      <div className={styles.leftSection}>
        <button onClick={onMenuClick} className={styles.menuBtn} aria-label={t("components:toggleMenu")}>
          <Menu className={shared.iconMd} />
        </button>
        <div className={styles.titleSection}>
          <h2 className={styles.pageTitle}>{pageTitle}</h2>
          <div className={styles.breadcrumbRow}>
            <span>{t("app.title")}</span>
            <span>/</span>
            <span className={styles.truncate}>{pageTitle}</span>
          </div>
        </div>
      </div>

      <div className={shared.rowGap2}>
        <LanguageSwitcher />
        <ThemeToggle />
        <div className={styles.divider} />
        <div className={shared.rowGap2}>
          <div className={styles.avatar} title={user?.name || user?.email || ""}>
            {getInitials(user?.name ?? null, user?.email ?? "")}
          </div>
          <span className={styles.userEmail}>{user?.email}</span>
          <button onClick={logout} className={styles.logoutBtn} aria-label={t("button.logout")} title={t("button.logout")}>
            <LogOut className={shared.iconSm} />
            <span className={styles.logoutText}>{t("button.logout")}</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default TopBar;
